import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";
import * as utilsUnderwriter from "../utils/underwriter";

const initialState = {
    underwriters: [],
    loading: false,
    saving: false,
    deleting: false
};

export default function underwriter(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_UNDERWRITER:
            newState.loading = true;
            break;

        case actions.SAVING_UNDERWRITER:
            newState.saving = true;
            break;

        case actions.RECEIVED_UNDERWRITERS:
            newState.underwriters = utils.mapById(utilsUnderwriter.flattenCountry(action.payload));
            newState.loading = false;
            break;

        case actions.SAVED_UNDERWRITER:
            let found = false;

            for (let i = 0; i < newState.underwriters.length; i++) {
                if(newState.underwriters[i].id === action.payload.id){
                    found = true;

                    newState.underwriters[i] = action.payload;
                }
            }

            if(!found) {
                newState.underwriters.add(
                    action.payload
                );
            }
            newState.underwriters = utils.mapById(utilsUnderwriter.flattenCountry(newState.underwriters));
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_UNDERWRITERS:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_UNDERWRITER:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_UNDERWRITER:
            newState.deleting = false;
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/underwriter.js